/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WearableUserProfileReport } from '../../models/wearable-user-profile-report';

export interface ReportDeviceConnectionGet$Params {

/**
 * Optional organization ID to filter results.
 */
  organizationId?: string;
}

export function reportDeviceConnectionGet(http: HttpClient, rootUrl: string, params?: ReportDeviceConnectionGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<Array<WearableUserProfileReport>>> {
  const rb = new RequestBuilder(rootUrl, reportDeviceConnectionGet.PATH, 'get');
  if (params) {
    rb.query('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<Array<WearableUserProfileReport>>;
    })
  );
}

reportDeviceConnectionGet.PATH = '/Report/DeviceConnection';
